// extracted by mini-css-extract-plugin
module.exports = {"Alert":"Alert","Alert__message":"Alert__message"};